/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_button_aria_label21 = /** @type {(inputs: {}) => string} */ () => {
	return `search`
};

const fr_search_button_aria_label21 = /** @type {(inputs: {}) => string} */ () => {
	return `recherche`
};

const de_search_button_aria_label21 = /** @type {(inputs: {}) => string} */ () => {
	return `Suche`
};

const es_search_button_aria_label21 = /** @type {(inputs: {}) => string} */ () => {
	return `buscar`
};

const it_search_button_aria_label21 = /** @type {(inputs: {}) => string} */ () => {
	return `ricerca`
};

const ar_search_button_aria_label21 = /** @type {(inputs: {}) => string} */ () => {
	return `بحث`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_button_aria_label21 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_button_aria_label21(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_button_aria_label21", locale)
	if (locale === "en") return en_search_button_aria_label21(inputs)
	if (locale === "fr") return fr_search_button_aria_label21(inputs)
	if (locale === "de") return de_search_button_aria_label21(inputs)
	if (locale === "es") return es_search_button_aria_label21(inputs)
	if (locale === "it") return it_search_button_aria_label21(inputs)
	return ar_search_button_aria_label21(inputs)
};
export { search_button_aria_label21 as "SEARCH_BUTTON_ARIA_LABEL" }